import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="text-primary text-6xl font-normal">404</h1>
      <p className="text-muted-foreground mt-4 text-lg">Page not found</p>
      <Link
        to="/home"
        className="bg-accent text-accent-foreground hover:bg-accent-hover mt-8 rounded-lg px-6 py-2 text-sm font-medium"
      >
        Go home
      </Link>
    </div>
  );
}
